import { Component, HostBinding, Input, Optional } from "@angular/core";
import { ControlContainer, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { DayOfWeek } from "src/app/enum/day-of-week";

@Component({
  selector: "days-toggle",
  templateUrl: "./days-toggle.component.html",
  styleUrls: ["./days-toggle.component.scss"]
})
export class DaysToggleComponent {
  @HostBinding("class.readonly")
  @Input()
  public readonly = false;

  @Input() public formGroup: FormGroup;
  @Input() public for = "deliveryDays";

  public readonly days: DayOfWeek[] = [
    DayOfWeek.Monday,
    DayOfWeek.Tuesday,
    DayOfWeek.Wednesday,
    DayOfWeek.Thursday,
    DayOfWeek.Friday,
    DayOfWeek.Saturday,
    DayOfWeek.Sunday
  ];

  constructor(
    @Optional() private _controlContainer: ControlContainer,
    private _translateService: TranslateService
  ) {}

  ngOnInit() {
    if (!this.formGroup && this._controlContainer?.control instanceof FormGroup) {
      this.formGroup = this._controlContainer.control as FormGroup;
    }
  }

  public get selectedDayLabels(): string {
    return this.days
      .filter((x) => this.isSelected(x))
      .map((x) => this.getDayShortLabel(x))
      .join(", ");
  }

  public isSelected(day: DayOfWeek): boolean {
    const value = this.formGroup?.get(this.for)?.value || {};
    return !!value[this.getDayKey(day)];
  }

  public toggleDay(day: DayOfWeek): void {
    if (this.readonly) {
      return;
    }
    const ctrl = this.formGroup?.get(this.for);
    if (!ctrl) {
      return;
    }
    const value = ctrl.value || {};
    const key = this.getDayKey(day);
    ctrl.setValue({
      ...value,
      [key]: !value[key]
    });
  }

  public getDayShortLabel(day: DayOfWeek): string {
    const dayName = this._translateService.instant(
      `enums.DayOfWeek.${this.getDayKey(day)}`
    );
    return dayName?.substring(0, 1) || "";
  }

  private getDayKey(day: DayOfWeek): string {
    return DayOfWeek[day];
  }
}

